<div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
  <div class="max-w-md w-full">
    <p-card styleClass="p-6 text-center">
      <!-- Header -->
      <div class="mb-6">
        <div class="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i class="pi pi-clock text-3xl text-yellow-600"></i>
        </div>
        <h1 class="text-2xl font-bold text-gray-800 mb-2" i18n>Account Pending Approval</h1>
        <p class="text-gray-600" i18n>Your account is currently under review by our administrators.</p>
      </div>

      <!-- Status Information -->
      <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
        <div class="flex items-center gap-3">
          <i class="pi pi-info-circle text-yellow-600"></i>
          <div class="text-left">
            <p class="font-medium text-yellow-800" i18n>What happens next?</p>
            <p class="text-sm text-yellow-700 mt-1" i18n>
              Our team will review your information and approve your account within 24-48 hours. 
              You'll receive an email notification once approved.
            </p>
            <p class="text-sm text-yellow-700 mt-2" i18n>Please check your email for the approval notification.</p>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-3">

        <button 
          pButton 
          type="button" 
          label="Login" i18n-label
          icon="pi pi-sign-in"
          class="w-full"
          (click)="goToLogin()"
        ></button>
      </div>

    </p-card>
  </div>
</div> 